export default (function () {
  for (var _len = arguments.length, fns = new Array(_len), _key = 0; _key < _len; _key++) {
    fns[_key] = arguments[_key];
  }

  return function (first) {
    return fns.reduce(function (previousValue, fn) {
      return fn(previousValue);
    }, first);
  };
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/rsuite/es/utils/composeFunctions.js
// module id = 410
// module chunks = 33